module.exports = global.config = {
    urls:{
        api:{
            // server: "http://localhost:3030"
            server: "https://api.linkurcodes.com"
        }
    }
}
